import React from 'react';

function NoResults({ searchTerm, onSearchChange }) {
  return (
    <div className="no-results-container">
      <div className="no-results-icon">🔍</div>
      <h3 className="no-results-title">No layers found</h3>
      <p className="no-results-message">
        No layers match your search criteria "<strong>{searchTerm}</strong>"
      </p>
      <div className="no-results-suggestions">
        <p>Try searching for:</p>
        <div className="suggestion-tags">
          <button 
            className="suggestion-tag"
            onClick={() => onSearchChange('python')}
          >
            python
          </button>
          <button 
            className="suggestion-tag"
            onClick={() => onSearchChange('node.js')}
          >
            node.js
          </button>
          <button 
            className="suggestion-tag"
            onClick={() => onSearchChange('java')}
          >
            java
          </button>
          <button 
            className="suggestion-tag"
            onClick={() => onSearchChange('dotnet')}
          >
            dotnet
          </button>
          <button 
            className="suggestion-tag"
            onClick={() => onSearchChange('arm64')}
          >
            arm64
          </button>
        </div>
      </div>
      <button 
        className="clear-search-suggestion"
        onClick={() => onSearchChange('')}
      >
        Show all layers
      </button>
    </div>
  );
}

export default NoResults;
